export enum LoginErrorCode {
  InvalidEmail = 1300,
  PasswordExpired = 1200,
  ValidateEmail = 1000,
  InvalidCredentials = 1100,
  VerifyOTE = 1500,
  InvalidOTE = 1503,
}
